import cx from 'clsx';
import * as React from 'react';

import { SMALL_BREAKPOINT } from '@/components/modular-grid/constants';
import { useWindowSize } from '@/hooks/useWindowSize';

import styles from './ContentWrapper.module.scss';

interface ContentWrapperPropTypes {
  children?: React.ReactNode;
  isSidebarInLayout?: boolean;
}

const ContentWrapper: React.FC<ContentWrapperPropTypes> = ({
  children = null,
  isSidebarInLayout,
}) => {
  const width = useWindowSize().width;
  const shouldContentBeVisible =
    width > SMALL_BREAKPOINT.max ||
    (width <= SMALL_BREAKPOINT.max && !isSidebarInLayout);
  return (
    <div
      id="contentWrapper"
      data-testid="contentWrapper"
      className={cx(styles.wrapper)}
    >
      <>{shouldContentBeVisible ? children : null}</>
    </div>
  );
};

export default ContentWrapper;
